import React from 'react';

import {
  normalizeConfidenceScore,
  normalizeEstimatedValueRange,
  toFiniteNumber,
} from '../../utils/formatters';

const formatMoney = (value) => `$${Math.round(value).toLocaleString()}`;

const getItemBounds = (item) => {
  const point = toFiniteNumber(item?.estimated_value);
  let low = toFiniteNumber(item?.estimated_value_low);
  let high = toFiniteNumber(item?.estimated_value_high);
  if (low === null || high === null) {
    const range = normalizeEstimatedValueRange(item);
    if (range) {
      if (low === null) low = range.low;
      if (high === null) high = range.high;
    }
  }
  if (low === null) low = point;
  if (high === null) high = point;
  return { low, high };
};

const StatCard = ({ label, value, valueClassName = 'text-ink', subtitle }) => (
  <div className="flex flex-col items-center justify-center gap-1 rounded-2xl bg-surface-2 dark:bg-white/[0.07] px-2 py-3 text-center">
    <span className="font-body text-[11px] leading-tight text-muted">{label}</span>
    <span className={`font-body text-2xl sm:text-3xl font-semibold leading-tight ${valueClassName}`}>{value}</span>
    <span className="font-body text-[10px] leading-3 text-muted">{subtitle || ' '}</span>
  </div>
);

const AnalysisSummaryStats = ({ items }) => {
  const list = Array.isArray(items) ? items : [];
  if (list.length === 0) return null;

  const total = list.reduce((sum, item) => sum + (toFiniteNumber(item?.estimated_value) || 0), 0);

  let rangeLow = 0;
  let rangeHigh = 0;
  let hasRange = false;
  list.forEach((item) => {
    const { low, high } = getItemBounds(item);
    if (low !== null) {
      rangeLow += low;
      hasRange = true;
    }
    if (high !== null) {
      rangeHigh += high;
      hasRange = true;
    }
  });

  const confidenceScores = list
    .map((item) => normalizeConfidenceScore(item?.confidence_score))
    .filter((score) => score !== null);
  const avgConfidence = confidenceScores.length
    ? Math.round((confidenceScores.reduce((sum, score) => sum + score, 0) / confidenceScores.length) * 100)
    : null;

  return (
    <div className="grid grid-cols-3 gap-2 sm:gap-3">
      <StatCard label="Detected Items" value={list.length} />
      <StatCard
        label="Est. Total Sum"
        value={formatMoney(total)}
        valueClassName="text-positive"
        subtitle={hasRange ? `range ${formatMoney(rangeLow)} - ${formatMoney(rangeHigh)}` : ''}
      />
      <StatCard
        label="Avg. Confidence"
        value={avgConfidence === null ? 'N/A' : `${avgConfidence}%`}
      />
    </div>
  );
};

export default AnalysisSummaryStats;
